import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from "react-redux";

import { getStaffByGuid } from '../../../../redux/selectors/scheduleAttendantSelectros'


const StaffName = props => {
    const { guid } = props;
    
    const staff = useSelector(getStaffByGuid(guid));

    return ( <span> {staff.name} </span> );
}

StaffName.propTypes = {
    guid: PropTypes.string
};

export default StaffName;